import { Component } from '@theme/component';

class VerticalFacetsToggleComponent extends Component {
  connectedCallback() {
    super.connectedCallback?.();
    const wrapper = this.closest('.collection-wrapper');
    if (wrapper) wrapper.classList.add('collection-wrapper--has-vertical-filter');
  }

  // The toggle state is preserved across section re-renders by a dedicated
  // case in `MORPH_OPTIONS.onBeforeUpdate` (see assets/morph.js): the live
  // panel's `.facets-collapsed` class and the bar button's `aria-expanded`
  // are mirrored onto the new node before morph's copyAttributes runs, so
  // the user's open/closed choice survives every filter change.
  toggle() {
    const isCollapsed = this.classList.toggle('facets-collapsed');
    const expanded = String(!isCollapsed);
    const controls = document.querySelectorAll(`[aria-controls="${this.id}"]`);
    for (const control of controls) {
      control.setAttribute('aria-expanded', expanded);
    }
  }
}

if (!customElements.get('vertical-facets-toggle-component')) {
  customElements.define('vertical-facets-toggle-component', VerticalFacetsToggleComponent);
}
